<template>
  <altcraft-popup
    v-if="shouldDisplayAltcraftPopup"
    :type="altcraftPopupData.type"
    @close="altcraftPopupClose"
    @subPush="altcraftPopupPush" />
</template>

<script>
import { hasTouch } from 'Root/helpers/tools';
import { MS_PER_DAY } from 'Root/helpers/DateConstants';
import Models from 'Models/UserModel';
import AltcraftPopupModel from 'Models/AltcraftPopupModel';
import localStorageManager from 'Root/helpers/localStorageManager';

import { mapState } from 'vuex';
import altcraftPopup from './AltcraftPopup.vue';

const LONG_TIME_MS = 40000;

export default {
  name: 'AltcraftContainer',

  components: {
    altcraftPopup,
  },

  data() {
    return {
      altcraftLongTimeTimer: null,
      altcraftPopupData: {
        isActive: true,
        type: '',
        isLongPageVisit: false,
        hasConflictingPopup: false,
      },
    };
  },

  computed: {
    ...mapState(['user', 'userReactiveStates', 'userDevice']),

    isUserAuthorized() {
      return !!this.user;
    },

    isReadyForAltcraftEmail() {
      return !this.isUserAuthorized
              && this.user === null
              && !localStorageManager.getFlag(AltcraftPopupModel.LOCALSTORAGE.EMAIL_SUBSCRIBED)
              && localStorageManager.getCooldown(AltcraftPopupModel.LOCALSTORAGE.EMAIL_COOLDOWN, MS_PER_DAY);
    },

    isReadyForAltcraftPush() {
      return this.isUserAuthorized
              && this.user?.role === Models.ROLES.CUSTOMER.id
              && typeof Notification === 'function'
              && !localStorageManager.getFlag(AltcraftPopupModel.LOCALSTORAGE.PUSH_SUBSCRIBED)
              && localStorageManager.getCooldown(AltcraftPopupModel.LOCALSTORAGE.PUSH_COOLDOWN, 3 * MS_PER_DAY);
    },

    hasOtherPopupsMobile() {
      return this.altcraftPopupData.hasConflictingPopup && hasTouch && this.userDevice.innerWidth < 768;
    },

    isVereficationPopupOpened() {
      return this.user
        && !this.user.email_verified_at
        && this.user.created_at > +process.env.SHOW_EMAIL_VERIFICATION_POPUP_TIME
        && this.user.role === Models.ROLES.CUSTOMER.id
        && !this.isPlatformApp
        && this.$route.name !== 'agreement'
        && !this.userReactiveStates.email_verify_later;
    },

    shouldDisplayAltcraftPopup() {
      return this.altcraftPopupData.isActive
              && !this.hasOtherPopupsMobile
              && this.altcraftPopupData.type.length > 0
              && !this.isVereficationPopupOpened
              && this.altcraftPopupData.isLongPageVisit;
    },
  },

  watch: {
    isUserAuthorized() {
      this.startPopupLogic();
    },

    'user.hasPassword': {
      handler() {
        this.startPopupLogic();
      },
    },

    'user.email_verified_at': {
      handler() {
        this.startPopupLogic();
      },
    },
  },

  mounted() {
    this.startPopupLogic();
    this.setupPopupEvents();
  },

  beforeDestroy() {
    this.clearLongTimeTimer();
  },

  methods: {
    clearLongTimeTimer() {
      if (this.altcraftLongTimeTimer) {
        clearTimeout(this.altcraftLongTimeTimer);
        this.altcraftLongTimeTimer = null;
      }
    },

    setupPopupEvents() {
      this._skGlobal.EVENTS.POPUP.OPEN.listen(this.handleConflictingPopupOpen);
      this._skGlobal.EVENTS.POPUP.CLOSE.listen(this.handleConflictingPopupClose);
    },

    handleConflictingPopupOpen() {
      this.altcraftPopupData.hasConflictingPopup = true;
    },

    handleConflictingPopupClose() {
      this.altcraftPopupData.hasConflictingPopup = false;
    },

    altcraftPopupResolveType() {
      if (this.isReadyForAltcraftEmail) {
        this.altcraftPopupData.type = AltcraftPopupModel.TYPE.EMAIL;
      }

      if (this.isReadyForAltcraftPush) {
        this.altcraftPopupData.type = AltcraftPopupModel.TYPE.PUSH;
      }
    },

    startPopupLogic() {
      this.clearLongTimeTimer();
      this.altcraftPopupShowLogic();
      this.altcraftPopupResolveType();
    },

    altcraftPopupShowLogic() {
      this.altcraftPopupData.isLongPageVisit = false;

      this.clearLongTimeTimer();
      this.altcraftLongTimeTimer = setTimeout(this.altcraftUpdateLongTimeOnPage, LONG_TIME_MS);
    },

    altcraftUpdateLongTimeOnPage() {
      this.altcraftPopupData.isLongPageVisit = true;

      if (this.isReadyForAltcraftPush) {
        localStorageManager.setFlag('shouldShowPushPopup', true);
      }
    },

    altcraftPopupClose() {
      this.altcraftPopupData.isActive = false;
    },

    altcraftPopupPush() {
      if (this.userDevice.isSafari || this.userDevice.innerWidth < 1280) {
        this.altcraftPopupClose();
      }

      this.altcraftPopupData.type = AltcraftPopupModel.TYPE.PUSH_PROMPT;
    },
  },
};
</script>
